import { parseSaving } from '../common/Helper';

// Reusable table cell renderers shared across all optimization page tables.

export const CostCell = ({ row }) => (
  <span style={{ fontWeight: '700', color: 'var(--text)' }}>{row.cost}</span>
);

export const RecommendedCostCell = ({ row }) => {
  const savings = row.savingValue > 0
    ? row.savingValue
    : row.recommendedCostValue > 0
      ? row.costValue - row.recommendedCostValue
      : 0;
  const pct = row.costValue > 0 && savings > 0
    ? ((savings / row.costValue) * 100).toFixed(1)
    : 0;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      <div style={{ fontWeight: '700', color: 'var(--text)' }}>{row.recommendedCost}</div>
      {savings > 0 && (
        <div style={{ fontSize: '10px', color: 'var(--green)', fontWeight: '600' }}>
          Save ${savings.toFixed(2)} ({pct}%)
        </div>
      )}
    </div>
  );
};

export const SavingCell = ({ row }) => {
  const val = parseSaving(row.saving);
  const color = val > 0 ? 'var(--green)' : val < 0 ? 'var(--red)' : undefined;
  return (
    <span style={color ? { color, fontWeight: 700 } : undefined}>
      {row.saving}
    </span>
  );
};

export const RecCell = ({ row }) => (
  <div className="rec-remark-wrap">
    <span className={`rec-pill ${row.recPillClass}`}>{row.recType}</span>
    {row.recLabel && <div className="rec-label-sub">{row.recLabel}</div>}
    {row.recommendationRemark &&
      row.recommendationRemark !== 'na' &&
      row.recommendationRemark !== 'NA' && (
        <div style={{ fontSize: '11px', color: 'var(--muted)', lineHeight: '1.3' }}>
          {row.recommendationRemark}
        </div>
      )}
  </div>
);


export const OsCell = ({ row }) => {
  if (!row.os || row.os === '—') return <span style={{ color: 'var(--muted)' }}>—</span>;
  const isLinux = row.os.toLowerCase() === 'linux';
  return (
    <span className="os-pill">
      <span className={`os-dot ${isLinux ? 'os-linux' : 'os-windows'}`} />
      {row.os}
    </span>
  );
};

export const StatusCell = ({ row }) => {
  const status = row.status || 'Unknown';
  const s = status.toLowerCase();
  let cls = 'st-warn'; // fallback / Deallocated reuses st-warn (yellow)
  if (s === 'running') cls = 'st-running';
  else if (s === 'stopped') cls = 'st-stopped';
  else if (s === 'stopping') cls = 'st-stopping';
  else if (s === 'deallocated') cls = 'st-warn';
  return <span className={`status-pill ${cls}`}>{status}</span>;
};

export const CpuCell = ({ row }) => {
  if (row.cpu == null) return <span style={{ color: 'var(--muted)' }}>—</span>;
  const val = Math.min(Math.max(row.cpu, 0), 100);
  const bucket = val < 25 ? 'low' : val < 70 ? 'med' : 'high';
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      <span className={`util-bar ${bucket}`}><div style={{ width: `${val}%` }} /></span>
      <span className="util-text">{row.cpu}%</span>
    </span>
  );
};

export const IdCell = ({ row }) => {
  const id = row.id || '';
  const truncated = id.length > 20 ? `${id.slice(0, 20)}…` : id;
  return (
    <span title={id} style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', fontSize: '11px' }}>
      {truncated}
    </span>
  );
};